// Core Domain Search API Client Extension

import { combineApiConfigs, createApiClient, createQueriesConfig } from '@wix/premium-fed-sdk/@apis-infra-react';
import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { CoreDomainSearchApiConfig } from '../../backend';
import { getKeywords } from '../../backend/queries';
export const CoreDomainSearchConfig = createQueriesConfig({
  getKeywords: {
    isMutating: false,
    errorCodesMap: {
      statusCodeError: {}
    },
    queryFn: getKeywords
  }
});
export const apiConfig = combineApiConfigs(CoreDomainSearchApiConfig, CoreDomainSearchConfig);

// Single API Client created from the config
export const {
  Provider,
  ...backend
} = createApiClient(apiConfig);

// Single API Client Extension
export const CoreDomainSearchApiClientExtension = createModuleExtension({
  extensionName: 'coreDomainSearchBackend',
  internals: {
    backend
  },
  Provider
});
//# sourceMappingURL=CoreDomainSearchApiClientExtension.js.map